<template>
    <div>
        <dl class="description-list-wrapper">
            <DescriptionItem :label="getLabel" mode="form" :labelFor="`edit-form-input-key-${detailData.key_name}`">
                <div class="w-100">

                    <b-form-input v-if="detailData.value_type === 'str'"
                                  :id="`edit-form-input-key-${detailData.key_name}`"
                                  v-model="input_key"
                                  :name="`edit-form-input-key-${detailData.key_name}`"
                                  :disabled="loading"
                                  autocomplete="new-password"
                    />
                    <b-form-input v-if="detailData.value_type === 'int'"
                                  :id="`edit-form-input-key-${detailData.key_name}`"
                                  v-model="input_key"
                                  :name="`edit-form-input-key-${detailData.key_name}`"
                                  :disabled="loading"
                                  autocomplete="new-password"
                    />
                    <b-form-select
                        v-if="detailData.value_type === 'list'"
                        :id="`edit-form-input-key-${detailData.key_name}`"
                        v-model="input_key"
                        :disabled="loading"
                        autocomplete="new-password"
                        :name="`edit-form-input-key-${detailData.key_name}`"
                        :options="parseAllowedValues"

                    />
                </div>
            </DescriptionItem>

        </dl>

        <div>
            <b-button variant="primary"
                      block
                      size="md"
                      @click="validateInputKey">
                <div class="d-flex align-items-center justify-content-center">
                    <b-spinner v-if="loading" small  class="mr-2"></b-spinner>
                    {{ $t('캠페인 찾기') }}
                </div>
            </b-button>
        </div>


        <template v-if="campaign_info">
            <h5 class="mt-5"> 연결 캠페인 </h5>
            <dl v-if="campaign_info.matched"
                class="description-list-wrapper"
            >
                <DescriptionItem :label="$t('캠페인명')">
                    {{ get_campaign_name}}
                </DescriptionItem>
                <DescriptionItem :label="$t('매칭 규칙 그룹 ID')">
                    <b-button variant="link" style="padding: 0"
                              @click="openRuleGroup"
                    >
                              
                        {{ campaign_info?.rule_set?.root_rule_group_id || '-' }}    
                    </b-button>
                    
                </DescriptionItem>
            </dl>
            <template v-else>
                <b-card>
                    {{ $t('매칭된 캠페인이 없습니다.')}}
                </b-card>
            </template>
        </template>
        
        <RuleGroupModal ref="ruleGroupModal"
                        :detail-id="campaign_info?.rule_set?.root_rule_group_id"
        />
    </div>

</template>

<script>
import {matchCampaign} from '@shared_utils/api/ruleEngine';
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import RuleGroupModal from '@shared/components/admin/pages/Management/CampaignConnectRule/RuleGroup/RuleGroupModal.vue';

export default {
    name: 'SchemaInputValidate',
    components: {
        RuleGroupModal,
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        },
        projects: {
            type: [Array, null],
            default: null,
        },
        allowedValues: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            input_key: '',
            loading: false,
            campaign_info: null,
        };
    },
    computed: {
        getLabel() {
            return this.detailData?.label_texts?.[this.$i18n.locale] || '-';
        },
        parseAllowedValues() {
            return this.allowedValues.map(item => ({
                value: item.actual_value,
                text: item[`label_texts_${this.$i18n.locale}`] || item.label_texts_ko
            }));
        },
        get_campaign_name(){
            if(!this.campaign_info) return '-';
            return `${this.campaign_info?.rule_set?.name} (${this.campaign_info?.rule_set?.id})`;
        }
    },
    methods: {
        async validateInputKey() {
            if(this.input_key == null || this.input_key === '') {
                this.$showModal({
                    type: 'alert',
                    state: 'warning',
                    title: this.$t('입력 오류'),
                    message: this.$t('값을 입력해주세요.'),
                });
                return;
            }
            
            try {
                this.loading = true;
                const {data: target_campaign_res} = await matchCampaign({
                    project_id: this.detailData.project_id,
                    user_inputs: {
                        [this.detailData.key_name]: this.input_key
                    }
                });

                this.campaign_info = target_campaign_res;
            }
            catch (e) {
                // 기존에는 빈 catch 로 삼켜서, 매칭 조회가 실패해도 화면이 직전
                // 결과를 그대로 보여줬다 (관리자가 실패를 알 수 없었다).
                this.campaign_info = null;
                this.$showModal({
                    type: 'alert',
                    state: 'error',
                    title: this.$t('검증 실패'),
                    message: this.$t('캠페인 매칭 조회에 실패했습니다. 잠시 후 다시 시도해주세요.'),
                });
            }
            finally {
                this.loading = false;
            }
            
        },
        openRuleGroup() {
            this.$refs.ruleGroupModal.changeMode('readOnly');
            this.$bvModal.show('rule-group-detail-modal');
        }
    },
};
</script>
<style lang="scss" scoped>

</style>
